"use strict";

module.exports = require("./Informer.js");